/** Inputs that determine why a recipe cannot run. */
export interface RecipeRunAvailability {
  interviewStatus: string;
  hasTranscript: boolean;
  userTurnCount: number | null;
  qualityMet: boolean;
  hasInProgress: boolean;
}

/** Resolve a stable recipe failure code to safe product copy. */
export function resolveRecipeErrorMessage(code?: string): string {
  if (code === 'transcript_empty') {
    return 'No answers to use.';
  }
  if (code === 'output_not_reliable') {
    return 'No reliable result was created.';
  }
  return 'This recipe could not run.';
}

/** Describe the first product condition that prevents a recipe run. */
export function getRecipeDisabledReason(
  availability: RecipeRunAvailability,
): string {
  if (availability.interviewStatus !== 'completed') {
    return 'Available when conversation ends.';
  }
  if (
    !availability.hasTranscript ||
    availability.userTurnCount === 0 ||
    !availability.qualityMet
  ) {
    return 'No answers to use.';
  }
  if (availability.hasInProgress) {
    return 'A generation is already in progress.';
  }
  return '';
}
